/*
  Synapex cart (sprint 24): check out answers the press. When the cart form is submitted by the check out button, the
  button takes aria-busy, which runs its one white strip (assets/sx-cart.css) while the checkout page loads, on a phone
  and a desktop alike. A page restored by Back clears it. Nothing here stops, delays or changes the submit.
*/
(() => {
  if (window.sxCartCheckout) return;
  window.sxCartCheckout = true;

  document.addEventListener('submit', (event) => {
    const button = event.submitter;
    if (!button || !button.matches('.cart__checkout-button')) return;
    setTimeout(() => {
      if (!event.defaultPrevented) button.setAttribute('aria-busy', 'true');
    });
  });

  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    document.querySelectorAll('.cart__checkout-button[aria-busy]').forEach((button) => button.removeAttribute('aria-busy'));
  });
})();
